<template>
    <div class="ip-list">
        <div class="flex items-center gap-2 mt-2">
            <form-input
                v-model="newIp"
                type="text"
                :placeholder="placeholder"
                :name="name"
                :label="label"
                class="w-full"
                @keypress.enter.prevent="addIp">
                <template #suffix>
                    <div class="w-30">
                        <form-button
                            size="mini"
                            :outline="false"
                            color="info"
                            type="button"
                            @click="addIp">
                            Thêm
                        </form-button>
                    </div>
                </template>
            </form-input>
        </div>
        <ul class="ip-list-items mt-3">
            <li
                v-for="(ip, index) in ipList"
                :key="index"
                class="flex items-center justify-between p-2 rounded-md mb-2">
                <span>
                    {{ ip }}
                </span>
                <form-button
                    type="button"
                    color="error"
                    size="mini"
                    @click="removeIp(index)">
                    {{ $t('labels.remove') }}
                </form-button>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { ref, defineEmits } from 'vue'

import formInput from './input.vue'
import formButton from './button.vue'

const props = defineProps({
  modelValue: {
    type: Array as () => string[],
    default: () => []
  },
  label: {
    type: String,
    default: 'IP cho phép'
  },
  placeholder: {
    type: String,
    default: 'Nhập địa chỉ IP'
  },
  name: {
    type: String,
    default: 'allowedIps'
  }
})

const emits = defineEmits(['update:modelValue'])

const newIp = ref('')
const errorMessage = ref('')
const ipList = ref([...props.modelValue])

const addIp = () => {
  const trimmedIp = newIp.value.trim()
  if (trimmedIp) {
    if (!isValidIp(trimmedIp)) {
      errorMessage.value = 'Ip chưa đúng định dạng'
      return
    }
    if (!ipList.value.includes(trimmedIp)) {
      ipList.value.push(trimmedIp)
      emits('update:modelValue', ipList.value)
      newIp.value = ''
    } else {
      alert('IP address already exists')
    }
  } else if (trimmedIp) {
    alert('Invalid IP address')
  }
}

const removeIp = (index: number) => {
  ipList.value.splice(index, 1)
  emits('update:modelValue', ipList.value)
}

const isValidIp = (ip: string): boolean => {
  const ipRegex =
    /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/
  return ipRegex.test(ip)
}
</script>

<style scoped>
/* .ip-list-items {
  list-style: none;
  padding: 0;
  margin: 0;
} */

/* .form-input {
  border: 1px solid #ccc;
  padding: 0.5rem;
  border-radius: 0.375rem;
} */

/* button {
  cursor: pointer;
} */
</style>
